// Frontend configuration for IVS Board Games
const PRODUCTION_LIVE_BACKEND_URL = 'https://ivs-board-games-live.sweet-tooth-51a1.workers.dev';
const LOCAL_LIVE_BACKEND_URL = 'http://127.0.0.1:8787';

function resolveLiveBackendUrl() {
  const location = globalThis.location;
  const isLocalFrontend = ['localhost', '127.0.0.1'].includes(location?.hostname);

  // Serving the frontend on localhost should work out of the box. The
  // production Worker explicitly allows localhost origins, so use it by
  // default instead of assuming a separate Wrangler dev process is running.
  //
  // Developers who intentionally want the local Worker can opt in with:
  //   http://localhost:8080/?backend=local
  if (isLocalFrontend) {
    const params = new URLSearchParams(location?.search || '');
    if (params.get('backend') === 'local') return LOCAL_LIVE_BACKEND_URL;
  }

  return PRODUCTION_LIVE_BACKEND_URL;
}

export const CONFIG = {
  // Cloudflare Worker Live Multiplayer WebSocket / HTTP URL
  LIVE_BACKEND_URL: resolveLiveBackendUrl(),

  getWsUrl(gameType, roomCode) {
    let base = CONFIG.LIVE_BACKEND_URL;
    if (base.startsWith('http://')) {
      base = base.replace('http://', 'ws://');
    } else if (base.startsWith('https://')) {
      base = base.replace('https://', 'wss://');
    }
    return `${base}/live?game=${encodeURIComponent(gameType)}&room=${encodeURIComponent(roomCode)}`;
  },

  getRoomsUrl() {
    return `${CONFIG.LIVE_BACKEND_URL}/api/rooms`;
  },

  getHealthUrl() {
    return `${CONFIG.LIVE_BACKEND_URL}/health`;
  }
};
